export enum THEME_COLORS {
  DARK = "dark",
  LIGHT = "light",
}
